import React, { Component } from 'react';

class Steps extends Component {
    render(){
        const stepsItems = (items) => {
            return items.map( (item, index) => (
                <div className={ "bs-wizard-step " + item.status } key={index}>
                    <div className="text-center bs-wizard-stepnum">{item.title}</div>
                    <div className="progress"><div className="progress-bar"></div></div>
                    <a href="#" className="bs-wizard-dot"></a>
                </div>
            ));
        };
        return(
            <div className="d-flex justify-content-between  bs-wizard">
                {stepsItems(this.props.steps)}
            </div>
        )
    }
}
export default Steps


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/newcaso/Steps.jsx